import { doLogout } from "../utils/doLogout";
import { apiService } from "./apiService";

const MRMBERS_API = "/members";

// 로그인 관련
export const memberLogin = async (data: LoginFormData): Promise<LoginResponse> => {
  try {
    const response = await apiService.post<LoginResponse>(`${MRMBERS_API}/login`, data);
    const token = response.auth.access_token;
    const refresh = response.auth.refresh_token;
    
    if (token && refresh) {
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refresh);
    } 
    
    return response;
  } catch (error) {
    throw error;
  }
};

export const memberLogout = async (href = "/") => {
  try {
    const response = await apiService.post<{ statusCode: number }>(`${MRMBERS_API}/logout`);

    if (response.statusCode) {
      doLogout(href);
    }
  } catch (error) {
    throw error;
  }
};

export const memberSingup = async (data: MemberSignupProps) => {
  try {
    const response = await apiService.post<any>(`${MRMBERS_API}/signup`, data);
    
    if (response.statusCode) {
      return response
    }
  } catch (error) {
    throw error;
  }
}

export const memberSignout = async (data: SignoutProps): Promise<SignoutResponse> => {
  try {
    const response = await apiService.delete<SignoutResponse>(`${MRMBERS_API}/signout`, data);
    return response;
  } catch (error) {
    throw error;
  }
}

// 유저 정보 관련
export const memberInfo = async (params: MemberInfoProps): Promise<MemberInfoResponse> => {
  try {
    const response = await apiService.get<MemberInfoResponse>(`${MRMBERS_API}/info`, params);
    return response;
  } catch (error) {
    throw error;
  }
}

export const memberList = async (params: MemberListProps): Promise<MemberListResponse> => {
  try {
    const response = await apiService.get<MemberListResponse>(`${MRMBERS_API}/list`, params);
    return response;
  } catch (error) {
    throw error;
  }
}

export const memberUpdate = async (data: MemberUpdateProps): Promise<MemberInfoResponse> => {
  try {
    const response = await apiService.post<MemberInfoResponse>(`${MRMBERS_API}/update`, data);
    return response;
  } catch (error) {
    throw error;
  }
}

// 정보 변경
export const memberChangePw = async (data: MemberChangePwProps): Promise<MemberInfoResponse> => {
  try {
    const response = await apiService.post<MemberInfoResponse>(`${MRMBERS_API}/change_pw`, data);
    return response;
  } catch (error) {
    throw error;
  }
}
